{#await promise}
  <SkeletonText/>
  <br/>
  <Accordion skeleton align="start" />
{:then data}

  {#await marker}
    <SkeletonText/>
  {:then data}
    <h3>{data.rs} || {id} </h3>

    <Row padding>
      <Column>
        <strong style="padding-right: 5px;">Species:</strong>{data.LitVar.data.species}</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>   

    <Row>
      <Column>
        <strong style="padding-right: 5px;">Position:</strong>
        Chr{data.LitVar.data.chromosome_base_position} ({data.dbSNP.assembly})
      </Column>
      <Column><strong style="padding-right: 5px;">Type:</strong>{data.type}</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>    
    
    <Row padding>
      <Column>
        <strong style="padding-right: 5px;">Alleles:</strong>{data.dbSNP.alleles}
      </Column>
      <Column><strong style="padding-right: 5px;">Gene:</strong>
        {data.LitVar.gene.name} ({data.LitVar.gene.id})</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>    
    
    <Row>
      <Column><strong style="padding-right: 5px;">dbSNP Cited:</strong>{data.dbSNP.pmid_citated}</Column>
      <Column><strong style="padding-right: 5px;">LitVar Cited:</strong>{data.LitVar.cited}</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>    
    
  {:catch}
    <p>No data</p>
  {/await}
  
  <br/>

  <Accordion align="start">
    
    <AccordionItem open>
      <div slot="title">
        <h5>Client Data</h5>
        <div>Classifications and rating</div>
      </div>
      
    <Row>
      <Column>
        <strong style="padding-right: 5px;">Risk allele:</strong>{data.risk_allele}</Column>
      <Column><strong style="padding-right: 5px;">GxE pos/neg:</strong>{data.GxE_pos} / {data.GxE_neg}</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>   

    <Row padding>
      <Column>
        <strong style="padding-right: 5px;">Panel:</strong>{data.panel_name}
      </Column>
      <Column><strong style="padding-right: 5px;">Search terms:</strong>{data.searcher}</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>    

    <Row>
      <Column>
        <strong style="padding-right: 5px;">Trait:</strong>{data.trait_name}</Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
      <Column></Column>
    </Row>    
    
    </AccordionItem>

    <AccordionItem>
      <div slot="title">
        <h5>Marker Stats</h5>
        <div>Details from dpSNP, LitVar</div>
      </div>
      {#await marker}
        <SkeletonText/>
      {:then data}
        <Row padding>
          <Column xlg={1}><strong style="padding-right: 5px;">Merges:</strong>
            <StructList style="margin-bottom: 1rem;">
              <StructHead>
                <StructRow head>
                  <StructCell head style="padding: .5rem .5rem .75rem .5rem;">RSid</StructCell>
                  <StructCell head style="padding: .5rem .5rem .75rem .5rem;">Rev</StructCell>
                  <StructCell head style="padding: .5rem .5rem .75rem .5rem;">Date</StructCell>
                </StructRow>
              </StructHead>
              <StructBody>
                {#each data.dbSNP.merges as m}
                  <StructRow>
                    <StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{m.merged_rsid}</StructCell>
                    <StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{m.revision}</StructCell>
                    <StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{m.merge_date.substr(0,10)}</StructCell>
                  </StructRow>
                {:else}
                  <StructRow>
                    <StructCell nowrap>None</StructCell>
                    <StructCell nowrap>0</StructCell>
                  </StructRow>
                {/each}
              </StructBody>
            </StructList>
          </Column>
          <Column></Column>
          <Column><strong style="padding-right: 5px;">LitVar Diseases (Top 5):</strong>
            <StructList style="margin-bottom: 1rem;">
              <StructHead>
                <StructRow head>
                  <StructCell head style="padding: .5rem .5rem .75rem .5rem;">Name</StructCell>
                  <StructCell head style="padding: .5rem .5rem .75rem .5rem;">PMID's</StructCell>
                </StructRow>
              </StructHead>
              <StructBody>
                {#each data.LitVar.diseases as dis}
                  <StructRow>
                    <StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{dis.name}</StructCell>
                    <StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{dis.count}</StructCell>
                  </StructRow>
                {:else}
                  <StructRow>
                    <StructCell nowrap>None</StructCell>
                    <StructCell nowrap>0</StructCell>
                  </StructRow>
                {/each}
              </StructBody>
            </StructList>
          </Column>
        </Row>
      {:catch}
        <p>No data</p>
      {/await}
    </AccordionItem>

    <AccordionItem bind:open={citOpen}>
      <div slot="title">
        <h5>Citation workspace</h5>
        <div>User reviewed and/or annotated citations for a marker</div>      
      </div>
      <Citations id={id} />
    </AccordionItem>
    
  </Accordion>
{:catch}
  <p>No data</p>
{/await}



<style>
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>

<script>
  export let id, snp
 
  import { navigate } from 'svelte-routing'  
  import { Firestore, Functions } from '../../config/firebase'
  
  import { 
		Grid,
		Row,
		Column,
    SkeletonText,
    Button,
    Modal,
    Loading,
    Accordion, AccordionItem,
		StructuredList as StructList,
    StructuredListHead as StructHead,
    StructuredListRow as StructRow,
    StructuredListCell as StructCell,
		StructuredListBody as StructBody,
		StructuredListSkeleton,
  } from "carbon-components-svelte"
  import ImportIcon from "carbon-icons-svelte/lib/DocumentImport32"

  import Citations from '../tables/client/Citations.svelte'

  let promise = getClientMarker(id)
  let marker = getMarker(snp)

  let open = false
  let citOpen = false

	async function getClientMarker(id) {
		try { 
			let doc = await Firestore.collection("snps").doc(id).get()
			if (doc.exists) {
        // console.log("snp:",doc.data())
        return await doc.data()
			} else { throw Error(`404 Client marker: ${id}`) }
		} catch (error) {
      throw Error(error)  
		}
	}

	async function getMarker(id) {
		try { 
			let doc = await Firestore.collection("markers").doc(id).get()
			if (doc.exists) {
        // console.log("mkr:",doc.data())
        return await doc.data()
			} else { throw Error(`404 Base marker: ${id}`) }
		} catch (error) {
      throw Error(error)  
		}
  }

	async function getClientCitations(id) {
		try { 
      let items =[]
			let snap = await Firestore.collection('snps').doc(id).collection('citations').get()
			if (snap.size > 0) {
        snap.forEach( doc => {
          let data = doc.data()
          data.id = doc.id
          items.push(data)
        })
        return items
			} else { return items }
		} catch (error) {
      throw Error(error)  
    }
  }

</script>